export default "__VITE_ASSET__DUhNlOSV__"